<div class="summary-tab-header">
  <p class="acta-tab-hint acta-tab-hint-info">
    @if (!has_eligible_diarization()) {
      El resumen con IA requiere al menos una grabación transcrita con diarización.
    } @else if (!has_summary_content()) {
      Puedes generar el resumen con IA a partir de una grabación ya transcrita.
    } @else {
      El resumen se genera automáticamente con IA y solo puede actualizarse volviendo a generarlo.
    }
  </p>

  @if (can_generate_summary()) {
    <button
      mat-stroked-button
      type="button"
      color="accent"
      class="summary-generate-button"
      [disabled]="is_generate_summary_disabled()"
      [matTooltip]="generate_summary_button_tooltip()"
      [matTooltipDisabled]="generate_summary_button_tooltip() === ''"
      (click)="onGenerateSummaryClick()"
    >
      @if (is_summary_generation_in_flight()) {
        <mat-spinner class="summary-generate-button-spinner" diameter="18"></mat-spinner>
        <span>Generando resumen...</span>
      } @else {
        <mat-icon class="summary-generate-button-icon" aria-hidden="true">auto_awesome</mat-icon>
        <span>Generar resumen con IA</span>
      }
    </button>
  }
</div>

@if (has_summary_content()) {
  <div class="summary-report" [innerHTML]="ai_summary_html_safe()" (click)="onSummaryReportClick($event)"></div>
} @else {
  <p class="summary-empty-hint">Aún no hay resumen generado.</p>
}
